import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RoutingService } from '@spartacus/core';
import { SearchBoxConfig } from '@spartacus/storefront';
import { Subscription } from 'rxjs';
import { OspSearchResultModel } from '../model/osp-search-result.model';
import { OspCategoriesService } from '../services/osp-categories.service';

const DEFAULT_SEARCH_BOX_CONFIG: SearchBoxConfig = {
  minCharactersBeforeRequest: 3,
  maxProducts: 5,
};

@Component({
  selector: 'app-custom-osp-search-result-header',
  templateUrl: './custom-osp-search-result-header.component.html',
  styleUrls: ['./custom-osp-search-result-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomOspSearchResultHeaderComponent implements OnInit, OnDestroy {
  searchResult: OspSearchResultModel;
  query: string;
  contentSub: Subscription;

  constructor(
    private readonly router: RoutingService,
    private readonly ospService: OspCategoriesService,
    protected readonly changeDetectorRef: ChangeDetectorRef,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.contentSub = this.ospService.contentItemsSearchResult$.subscribe(
      (res) => {
        if (res != null) {
          this.searchResult = res;
          this.changeDetectorRef.detectChanges();
        }
      }
    );
  }

  ngOnDestroy(): void {
    this.contentSub?.unsubscribe();
  }

  redirectToHelpCenter() {
    this.router.goByUrl('/help-center/all');
  }
}
